/**
 * Copyright (c) 2020, hitobito AG. This file is part of
 * hitobito and licensed under the Affero General Public License version 3
 * or later. See the COPYING file at the top-level directory or at
 * https://github.com/hitobito/hitobito.
 */





// Antique Gems that provide JavaScript/CSS do not publish an NPM
// package with these assets. We're using ERB to determine the
// file paths of these assets to include them into the bundle.

// remotipart
import {} from '/opt/bundle/ruby/3.2.0/gems/remotipart-1.4.4/vendor/assets/javascripts/jquery.iframe-transport.js';
import {} from '/opt/bundle/ruby/3.2.0/gems/remotipart-1.4.4/vendor/assets/javascripts/jquery.remotipart.js';
